<!--used to display the vault archive details of saved items
In (ui) discovery tool-> overview-> select any active project-> go to saved items-> vault archives-> open any mail
-->
<template>
  <v-container class="boxContainer archive-detail">
    <div v-if="archiveDetails" class="pb-2 mt-2">
      <v-row class="mb-2">
        <v-icon @click="goToSavedItems()" class="pointer"
          >arrow_back_ios</v-icon
        >

        <v-col class="pa-0">
          <!-- <span>Subject&nbsp;:&nbsp;</span> -->
          <h2>{{ archiveDetails.filename || archiveDetails.fileName }}</h2>
        </v-col>
      </v-row>
      <v-row class="pl-3" no-gutters>
        <v-col>
          <!-- For teams/dropbox archives -->
          <v-row class="mb-2" v-if="isTeams || isDropbox" no-gutters>
            <v-col class="pa-0">
              <span>Accessible by&nbsp;:&nbsp;</span>
              <span class="description-item">{{ accessibleBy }}</span>
            </v-col>
          </v-row>
          <v-row
            class="mb-2"
            v-else-if="archiveDetails.version !== '-'"
            no-gutters
          >
            <v-col class="pa-0">
              <span>Accessible by&nbsp;:&nbsp;</span>
              <span
                class="description-item"
                v-for="owner in archiveDetails.ownerIds"
                :key="owner"
                >{{ formatUserName(userIdNameMap[owner]) }}{{ '; ' }}</span
              >
            </v-col>
          </v-row>
          <v-row class="mb-2" v-if="!isTeams && archiveDetails" no-gutters>
            <v-col class="pa-0">
              <!-- <span>Subject&nbsp;:&nbsp;</span> -->
              <span>Synced at&nbsp;:&nbsp;</span>
              <span class="description-item">{{
                getFormatedDateAsPerTimeAndDate(archiveDetails.lastUpdatedAt)
              }}</span>
            </v-col>
          </v-row>
          <v-row class="mb-2" v-if="archiveDetails.version !== '-'" no-gutters>
            <v-col class="pa-0">
              <span>Version&nbsp;:&nbsp;</span>
              <span class="description-item">{{ archiveDetails.version }}</span>
              <span class="description-item">
                {{
                  archiveDetails.latestVersion
                    ? ' ( It is latest version )'
                    : ' ( It is previous version )'
                }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-row v-else>
      <v-col sm="6">
        <v-skeleton-loader type="article" :loading="true"></v-skeleton-loader>
      </v-col>
      <v-col sm="6">
        <v-skeleton-loader
          type="actions"
          :loading="true"
          tile
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <!-- Chat box -->
    <chat-box-view v-if="isTeams" @setMetaDataForTeams="setMetaDataForTeams" />
    <RenderAttachment
      v-else-if="archiveDetails"
      class="ml-3"
      @setPdfStatus="pdfStatus => (pdfLoading = pdfStatus)"
      :archiveDetails="archiveDetails"
      :attachmentIndex="1"
      :type="'VAULT_O365_ARCHIVE'"
    />
  </v-container>
</template>
<script>
import RenderAttachment from './AttachmentRender/RenderAttachment';
import VaultDataService from '@/services/VaultDataService';
import ChatBoxView from '@/components/Discovery/AttachmentRender/ChatBoxView';
export default {
  components: { RenderAttachment, ChatBoxView },
  data() {
    return {
      // No use as of now. Might be useful for render of multiple files
      pdfLoading: false,
      archiveId: this.$route.params.archiveId,
      projectId: this.$route.params.projectId,
      archiveDetails: null
    };
  },

  computed: {
    isTeams() {
      const connectorType = this.$route.params.connectorType || '';
      return (
        connectorType.toLocaleLowerCase() === 'o365_teams' ||
        this.propsSourceType === 'o365_teams'
      );
    },
    isDropbox() {
      const connectorType = this.$route.params.connectorType || '';
      return (
        connectorType.toLocaleLowerCase() === 'dropbox' ||
        this.propsSourceType === 'dropbox'
      );
    },
    accessibleBy() {
      // For dropbox archive:- read accessibleBy
      // For other vault archives :- read ownerIds
      const accessibleByList = this.isDropbox
        ? this.archiveDetails.accessibleBy
        : this.archiveDetails.ownerIds;
      const accessibleByNames = (accessibleByList || []).map(
        senderDetails => this.getMessageSenderName(senderDetails || {}) || ''
      );
      return accessibleByNames.join(', ');
    }
  },

  mounted() {
    // if archive is other than teams type
    if (!this.isTeams) {
      this.getArchiveMetaData();
    }
  },
  methods: {
    // To set meta data for teams archive
    setMetaDataForTeams({ name, accessibleBy }) {
      this.archiveDetails = {
        filename: name || '',
        version: '-',
        ownerIds: accessibleBy || []
      };
    },

    // gets meta data of vault archive mail
    async getArchiveMetaData() {
      const response = await VaultDataService.getConnectorArchiveReports({
        // eslint-disable-next-line
        archiveId: String(this.archiveId),
        // TODO: replace it with discovery
        type: 'yourArchives',
        version: this.isDropbox ? 'v2' : ''
      });
      const parsedResponse = this.parseResponse(response);
      this.archiveDetails = parsedResponse;
    },
    // go back to saved items route
    goToSavedItems() {
      this.$router.replace(
        `/discovery/projects/${this.projectId}/archives/vault/p1`
      );
    }
  }
};
</script>
<style>
.scale-up-center {
  -webkit-animation: scale-up-center 0.6s cubic-bezier(0.39, 0.575, 0.565, 1)
    infinite both;
  animation: scale-up-center 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) infinite
    both;
}

button.addIcon.scale-up-center {
  background: #58e2c2;
}

button.addIcon.scale-up-center i {
  color: #fff;
}
@keyframes scale-up-center {
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}

.archive-detail .v-btn {
  border-radius: 0;
}

.archive-detail .comment_desc {
  overflow-wrap: break-word;
}
.stripIndicator {
  width: 100%;
  height: 9px;
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
}
.tags,
.discovery_tag_bg {
  background-color: #7440fb;
}
.comment,
.discovery_comment_bg {
  background-color: #58e2c2;
}
.data-tag {
  padding: 40px;
  border: solid 1.5px #bfbfbf;
  overflow-y: hidden;
  height: 100%;
}
.email-data {
  position: relative;
  height: 100vh;
}

.tag_box .v-btn {
  border-radius: 0 !important;
}
.addIcon::before {
  border-radius: 50% !important;
  background-color: #d8d8d8;
  width: 38px;
  height: 38px;
}
.addIcon {
  background-color: #d8d8d8;
  width: 38px !important;
  height: 38px !important;
  border-radius: 50% !important;
}
.data-actions {
  position: absolute;
  top: 50%;
  right: -20px;
}
.addChild {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: calc(100% + 15px);
  top: calc(50% - 38px);
}
.row .col span {
  font-weight: 600;
}
.description-item {
  color: #525252;
  font-size: 14px;
}
</style>
